/* buy-once-no-discount.js
   Adds a single product to cart (from data attributes) and redirects to checkout.
   Expects an anchor with id="buy-once-no-discount" and data-variant-id, optional data-quantity and data-clear-cart.
*/
(function () {
  var link = document.getElementById("buy-once-no-discount");
  if (!link) return;

  var variantId = link.getAttribute("data-variant-id");
  if (!variantId) {
    // No metafield / no variant — keep it inert
    link.addEventListener("click", function (e) {
      e.preventDefault();
    });
    return;
  }

  async function addAndGo(e) {
    e.preventDefault();
    if (link.dataset.busy === "1") return;

    link.dataset.busy = "1";
    var originalLabel = link.textContent;
    link.textContent = "Processing…";

    var clearCart = (link.getAttribute("data-clear-cart") || "true") === "true";
    var qty = parseInt(link.getAttribute("data-quantity") || "1", 10);
    if (isNaN(qty) || qty < 1) qty = 1;

    try {
      if (clearCart) {
        await fetch("/cart/clear.js", { method: "POST" });
      }

      var payload = { id: Number(variantId), quantity: qty };
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      window.location.assign("/checkout");
    } catch (err) {
      console.error("Buy-once add error:", err);
      link.textContent = "Try again";
      setTimeout(function () {
        link.textContent = originalLabel;
        link.dataset.busy = "0";
      }, 1500);
    }
  }

  link.addEventListener("click", addAndGo);
})();
